module.exports = __webpack_public_path__ + "media/images/abacus-carbono-white-673d0619.png";